<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.8161 17.0129L13.4393 16.0074L10.8928 17.5297L9.11607 17.529L6.56804 16.0074L3.19274 17.0129L2.16602 13.5469L3.19274 9.70018L2.16602 6.44785L3.19274 2.41699L8.46692 5.56804H11.5419L16.8161 2.41699L17.8428 6.44785L16.8161 9.70018L17.8428 13.5469L16.8161 17.0129Z"
      fill="#FF5C16"
    />
    <path d="M3.19336 2.41699L8.46754 5.57025L8.25778 7.73429L3.19336 2.41699Z" fill="#FF5C16" />
    <path d="M6.56836 13.5488L8.88897 15.3166L6.56836 16.0079V13.5488Z" fill="#FF5C16" />
    <path
      d="M8.70283 10.6254L8.25681 7.73535L5.40186 9.7005L5.40039 9.69976V9.70124L5.40922 11.7241L6.56695 10.6254H6.56769H8.70283Z"
      fill="#FF5C16"
    />
    <path d="M16.8152 2.41699L11.541 5.57025L11.75 7.73429L16.8152 2.41699Z" fill="#FF5C16" />
    <path d="M13.4398 13.5488L11.1191 15.3166L13.4398 16.0079V13.5488Z" fill="#FF5C16" />
    <path
      d="M14.6064 9.70124H14.6071H14.6064V9.69976L14.6057 9.7005L11.7507 7.73535L11.3047 10.6254H13.4398L14.5983 11.7241L14.6064 9.70124Z"
      fill="#FF5C16"
    />
    <path d="M6.56804 16.0069L3.19274 17.0124L2.16602 13.5479H6.56804V16.0069Z" fill="#E34807" />
    <path d="M8.70254 10.625L9.34728 14.803L8.45378 12.48L5.4082 11.7244L6.56667 10.625H8.70181H8.70254Z" fill="#E34807" />
    <path d="M13.4414 16.0069L16.8167 17.0124L17.8434 13.5479H13.4414V16.0069Z" fill="#E34807" />
    <path d="M11.3049 10.625L10.6602 14.803L11.5537 12.48L14.5992 11.7244L13.44 10.625H11.3049Z" fill="#E34807" />
    <path
      d="M2.16602 13.547L3.19274 9.7002H5.40074L5.40884 11.7238L8.45441 12.4794L9.34791 14.8023L8.88865 15.314L6.56804 13.5462H2.16602V13.547Z"
      fill="#FF8D5D"
    />
    <path
      d="M17.8421 13.547L16.8153 9.7002H14.6073L14.5992 11.7238L11.5537 12.4794L10.6602 14.8023L11.1194 15.314L13.44 13.5462H17.8421V13.547Z"
      fill="#FF8D5D"
    />
    <path d="M11.5418 5.56836H10.0043H8.46684L8.25781 7.73239L9.34783 14.8004H10.6609L11.7516 7.73239L11.5418 5.56836Z" fill="#FF8D5D" />
    <path d="M3.19274 2.41699L2.16602 6.44785L3.19274 9.70018H5.40074L8.25716 7.73429L3.19274 2.41699Z" fill="#661800" />
    <path d="M8.0644 11.4646H7.06417L6.51953 11.9984L8.45448 12.4782L8.0644 11.4639V11.4646Z" fill="#661800" />
    <path d="M16.8164 2.41699L17.8431 6.44785L16.8164 9.70018H14.6084L11.752 7.73429L16.8164 2.41699Z" fill="#661800" />
    <path d="M11.9455 11.4646H12.9472L13.4918 11.9991L11.5547 12.4797L11.9455 11.4639V11.4646Z" fill="#661800" />
    <path d="M10.8928 16.1508L11.121 15.3153L10.6617 14.8037H9.34794L8.88867 15.3153L9.11683 16.1508" fill="#661800" />
    <path d="M10.8912 16.1504V17.53H9.11523V16.1504H10.8912Z" fill="#C0C4CD" />
    <path d="M6.56836 16.0057L9.11713 17.5295V16.1499L8.88897 15.3145L6.56836 16.0057Z" fill="#E7EBF6" />
    <path d="M13.4413 16.0057L10.8926 17.5295V16.1499L11.1207 15.3145L13.4413 16.0057Z" fill="#E7EBF6" />
  </svg>
</template>
